<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <inertia-link
                        class="bg-blue-500 text-sm hover:bg-blue-700 text-white text-base font-bold py-3 px-6 rounded my-3"
                        :href="route('boleto.create')"
                    >
                        Novo boleto
                    </inertia-link>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Registro de boletos
                </h2>
            </div>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div
                    class="bg-white shadow-xl sm:rounded-lg px-4 py-4"
                >
                    <flash :timeout="5000" />
                    <inertia-table
                        class="text-xs"
                        :data="boletos"
                        :enable-display="true"
                        :params="params"
                        :filters="filters"
                        :columns="columns"
                        id="id"
                        routeName="boleto.index"
                        @item-selected="show"
                    >
                        <template
                            slot-scope="row"
                            slot="contact_account.bank.name"
                        >
                            {{ row.item.contact_account.bank.name }}
                        </template>
                        <template slot-scope="row" slot="pagador.nomeRazao">
                            <div class="text-left">
                                {{ row.item.pagador.nomeRazao }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="dadosBoleto.numDocTit">
                            <div class="text-center">
                                {{ row.item.dadosBoleto.numDocTit }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="identdNossoNum">
                            <div class="text-center">
                                {{ row.item.identdNossoNum }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="dadosBoleto.dtEmissao">
                            <div class="text-center">
                                {{ row.item.dadosBoleto.dtEmissao | smallDate }}
                            </div>
                        </template>
                        <template
                            slot-scope="row"
                            slot="dadosBoleto.dtVencimento"
                        >
                            <div class="text-center">
                                {{
                                    row.item.dadosBoleto.dtVencimento
                                        | smallDate
                                }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="dadosBoleto.vlrTitulo">
                            <div class="text-right">
                                {{ row.item.dadosBoleto.vlrTitulo | currency }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="status">
                            <div class="text-center">
                                {{ statusList[row.item.status] }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="actions">
                            <div v-if="row.item.status !== 'paid' && row.item.status !== 'paid-pix'" class="text-center">
                                <button
                                    class="text-red-600"
                                    content="Excluir"
                                    v-tippy
                                    @click="handleDeleteId(row.item.id)"
                                >
                                    <i class="fas fa-trash-alt"/>
                                </button>
                            </div>
                        </template>
                    </inertia-table>
                </div>
            </div>
        </div>
        <jet-dialog-modal :maxWidth="'md'" :position="'fixed'" :show="showModalDelete" @close="showModalDelete = false">
            <template #title>
                <p class="text-gray-500 text-xs">Confirmação de exclusão</p>
            </template>
            <template #content>
            <div class="text-md mt-4">
                <span> Esta ação é irreversível, você realmente deseja excluir este boleto?</span>
            </div>
            </template>
            <template #footer>
                <jet-secondary-button @click.native="showModalDelete = false">
                    Cancelar
                </jet-secondary-button>
                <jet-ok-button class="ml-2" @click.native="deleteItemId">
                    ok
                </jet-ok-button>
            </template>
        </jet-dialog-modal>
    </app-layout>
</template>
<script>
import AppLayout from "./../../Layouts/AppLayout";
import Welcome from "./../../Jetstream/Welcome";
import Dropdown from "../../Jetstream/Dropdown";
import DropdownLink from "../../Jetstream/DropdownLink";
import JetAutoComplete from "../../Jetstream/AutoComplete";
import Flash from "../../Helpers/Flash";
import InertiaTable from "../../Helpers/Tables/InertiaTable";
import JetDialogModal from "../../Jetstream/DialogModal.vue";
import JetSecondaryButton from "../../Jetstream/SecondaryButton.vue"
import JetOkButton from "../../Jetstream/OkButton.vue";

export default {
    components: {
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable,
        JetDialogModal,
        JetSecondaryButton,
        JetOkButton
    },
    props: ["boletos"],
    data() {
        return {
            showModalDelete: false,
            itemToDelete: null,
            columns: [
                {
                    text: "Pagador",
                    className: "text-left",
                    key: "pagador.nomeRazao",
                    sortable: true
                },
                {
                    text: "Número Documento",
                    className: "text-center",
                    key: "dadosBoleto.numDocTit",
                    sortable: true
                },
                {
                    text: "Nosso Número",
                    className: "text-center",
                    key: "identdNossoNum",
                    sortable: true
                },
                {
                    text: "Dt. Emissão",
                    className: "text-center",
                    key: "dadosBoleto.dtEmissao",
                    sortable: true
                },
                {
                    text: "Dt. Vencimento",
                    className: "text-center",
                    key: "dadosBoleto.dtVencimento",
                    sortable: true
                },
                {
                    text: "Status",
                    className: "text-center",
                    key: "status",
                    sortable: true
                },
                {
                    text: "Valor",
                    className: "text-right",
                    key: "dadosBoleto.vlrTitulo",
                    sortable: true
                },
                 {
                    text: "",
                    className: "text-right",
                    key: "actions",
                }
            ],
            filters: [
                {
                    text: "Status",
                    key: "status",
                    type: "dropdown",
                    colSpan: 2,
                    options: [
                        { id: "pending", name: "Pendente de registro" },
                        { id: "error", name: "Erro de registro" },
                        { id: "registered", name: "Registrado" },
                        { id: "paid", name: "Pago" },
                        { id: "expired", name: "Vencido" },
                        { id: "canceled", name: "Cancelado" }
                    ]
                },
                {
                    text: "Vencimento de",
                    key: "date_from",
                    type: "datepicker",
                    colSpan: 2
                },
                {
                    text: "Vencendo até",
                    key: "date_to",
                    type: "datepicker",
                    colSpan: 2
                }
            ],
            statusList: {
                approved: "Crédito aprovado",
                pending: "Aguardando registro",
                error: "Erro",
                registered: "Registrado",
                paid: "Pago",
                expired: "Vencido",
                canceled: "Cancelado",
                "paid-pix": "Pago com pix"
            },
            params: {
                sort: "dtVencimento:desc",
                page: 1,
                ...this.$page.props.queryString
            }
        };
    },
    methods: {
        handleDeleteId(id) {
           this.showModalDelete = true;
           this.itemToDelete = id;
        },
        deleteItemId() {
            const endpoint = `/boleto/${this.itemToDelete}/delete`
            this.$inertia.post(endpoint);
            this.showModalDelete = false;
       },
        show: function(item) {
            this.$inertia.get(this.route("boleto.show", item.id));
        }
    }
};
</script>
